export default __webpack_public_path__ + "static/media/Img0013.d8cf1155.png";